import { FC, useEffect, useState, Dispatch, SetStateAction, useRef } from 'react';
import { DialogWithActions, LocationIcon, DarkPlusIcon } from 'Components';
import { Box, Typography, Button, Select, MenuItem, FormControl } from '@material-ui/core';
import { AdressItemType } from 'Models/OnGetCustomerInfoModel';
import { colors, fontSizes, gutters } from 'Theme/Variables';
import { onAddApplicationBodyData } from 'Config';
import { formatAddressText } from 'Utils';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveUserAdress, getTownListRequest, AccountState, storeAccount } from 'Stores/Account';

import './AdressList.scss';
import {
  ApplicationProcessState,
  applicationStore,
  closeApplicationEmtpyAdressError,
  incStep,
  openApplicationEmtpyAdressError,
  openEmptyStreetError,
  setApplicationData,
} from 'Stores/CardApplication';
import { useLocalization } from 'Hooks';
import { addressInvalid } from '../helper';

export type AddressDetail = {
  AddressType?: any;
  CountryCode?: number;
  City?: string;
  CityCode?: number;
  TownCode?: string | number;
  District?: string;
  Street?: string;
  AddressDetail?: string;
  PostalCode?: string;
};

type AdressListProps = {
  adressList: Array<AdressItemType>;
  setIsAddNewAdress: Dispatch<SetStateAction<boolean>>;
  onEditChangeAddress: () => void;
  fillExportedData: (e: any) => void;
};
const AdressList: FC<AdressListProps> = ({ adressList, setIsAddNewAdress, fillExportedData, onEditChangeAddress }) => {
  const {
    web_btn_okay,
    web_card_incorrect_adkn_address_alert_title,
    web_card_incorrect_adkn_address_alert_desc,
    web_card_incorrect_address_alert_title,
    web_card_incorrect_address_alert_desc,
    web_enter_new_address,
  } = useLocalization();
  const dispatch = useDispatch();

  const store: ApplicationProcessState = useSelector(applicationStore);

  const { activeApplicationData, applicationEmtpyAdressError } = store;
  const accountStore: AccountState = useSelector(storeAccount);
  const { townList } = accountStore;

  const currentAdressFromState = activeApplicationData?.AddressDetail;

  const appAdress: AdressItemType = {
    AddressDetail: currentAdressFromState?.AddressDetail || '',
    AddressType: currentAdressFromState?.AddressType || '0',
    CityCode: currentAdressFromState?.CityCode || 0,
    District: currentAdressFromState?.District || '',
    Street: currentAdressFromState?.Street || '',
    PostalCode: String(currentAdressFromState?.PostalCode) || '',
    Town: String(currentAdressFromState?.Town || ''),
    ApartmentNumber: currentAdressFromState?.ApartmentNumber || '',
    BuildingNumber: currentAdressFromState?.BuildingNumber || '',
  };

  const [currentAdress, setCurrentAdress] = useState<AdressItemType | any>(
    appAdress.AddressDetail !== '' ? appAdress : adressList[0]
  );

  // DÖNGÜ RİSKİ: useMemo kaldırıldı
  const getSelectValue = () => {
    if (!currentAdress?.AddressDetail) {
      return -1;
    }

    const foundIndex = adressList.findIndex(
      (addr) =>
        addr.CityCode === currentAdress?.CityCode &&
        addr.AddressDetail === currentAdress?.AddressDetail &&
        addr.Town === currentAdress?.Town
    );

    return foundIndex !== -1 ? foundIndex : -2;
  };

  const selectValue = getSelectValue();

  const formControlRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (appAdress.AddressDetail === '') {
      // İlk adres seçiminde hem setApplicationData hem de setActiveUserAdress çağır
      const firstAdress = adressList[0];
      dispatch(
        setApplicationData({
          AddressDetail: {
            AddressDetail: firstAdress.AddressDetail,
            AddressType: firstAdress.AddressType,
            District: firstAdress.District,
            CityCode: firstAdress.CityCode,
            PostalCode: firstAdress.PostalCode,
            Street: firstAdress.Street,
            Town: firstAdress.Town,
            ApartmentNumber: firstAdress.ApartmentNumber,
            BuildingNumber: firstAdress.BuildingNumber,
          },
        })
      );

      // setActiveUserAdress'i de çağır
      dispatch(
        setActiveUserAdress({
          adressDetail: firstAdress.AddressDetail,
          adressType: firstAdress.AddressType.toString(),
          cityCode: firstAdress.CityCode.toString(),
          town: firstAdress.Town,
          district: firstAdress.District,
          street: firstAdress.Street,
          buildingNumber: firstAdress.BuildingNumber,
          apartmentNumber: firstAdress.ApartmentNumber,
          postalCode: firstAdress.PostalCode,
        })
      );
    } else {
      // Mevcut adres kullanılırken de setActiveUserAdress çağır
      setCurrentAdress(appAdress);

      // appAdress'ten apartment/building bilgilerini bul, yoksa adressList'ten bul
      const matchingAdress = adressList.find(
        (addr) =>
          addr.CityCode === appAdress.CityCode &&
          addr.AddressDetail === appAdress.AddressDetail &&
          addr.Town === appAdress.Town
      );

      // BURADA EKSİKTİ! Mevcut adres için de setActiveUserAdress çağır
      dispatch(
        setActiveUserAdress({
          adressDetail: appAdress.AddressDetail,
          adressType: appAdress.AddressType?.toString() || '',
          cityCode: appAdress.CityCode?.toString() || '',
          town: appAdress.Town || '',
          district: appAdress.District || '',
          street: appAdress.Street || '',
          buildingNumber: appAdress?.BuildingNumber,
          apartmentNumber: appAdress?.ApartmentNumber,
          postalCode: appAdress.PostalCode || '',
        })
      );
    }
    currentAdress?.AddressType === 7 ? setIsAddNewAdress(true) : setIsAddNewAdress(false);
  }, []); // DÖNGÜ DÜZELTİLDİ: dependency kaldırıldı

  // Component mount olduğunda da kontrol et - dependency'leri ekleyelim
  useEffect(() => {
    // Hem currentAdress hem de adressList hazır olduğunda çalış
    if (currentAdress?.AddressDetail && adressList?.length > 0 && currentAdress?.AddressType !== 7) {
      const matchingAdress = adressList.find(
        (addr) =>
          addr.CityCode === currentAdress?.CityCode &&
          addr.AddressDetail === currentAdress?.AddressDetail &&
          addr.Town === currentAdress?.Town
      );

      const buildingNumberValue = matchingAdress?.BuildingNumber || currentAdress.BuildingNumber;
      const apartmentNumberValue = matchingAdress?.ApartmentNumber || currentAdress.ApartmentNumber;

      dispatch(
        setActiveUserAdress({
          adressDetail: currentAdress.AddressDetail,
          adressType: currentAdress.AddressType?.toString() || '',
          cityCode: currentAdress.CityCode?.toString() || '',
          town: currentAdress.Town || '',
          district: currentAdress.District || '',
          street: currentAdress.Street || '',
          buildingNumber: buildingNumberValue,
          apartmentNumber: apartmentNumberValue,
          postalCode: currentAdress.PostalCode || '',
        })
      );
    }
  }, []); // DÖNGÜ DÜZELTİLDİ: tüm dependency'ler kaldırıldı

  const setDefaultAdress = (adress: AdressItemType) => {
    dispatch(
      setApplicationData({
        AddressDetail: {
          AddressDetail: adress.AddressDetail,
          AddressType: adress.AddressType,
          District: adress.District,
          CityCode: adress.CityCode,
          PostalCode: adress.PostalCode,
          Street: adress.Street,
          Town: adress.Town,
          TownCode: adress.Town,
          ApartmentNumber: adress.ApartmentNumber,
          BuildingNumber: adress.BuildingNumber,
        },
      })
    );

    // setActiveUserAdress çağrısını da ekle ki apartmentNumber ve buildingNumber bilgileri aktarılsın
    dispatch(
      setActiveUserAdress({
        adressDetail: adress.AddressDetail,
        adressType: adress.AddressType.toString(),
        cityCode: adress.CityCode.toString(),
        town: adress.Town,
        district: adress.District,
        street: adress.Street,
        buildingNumber: adress.BuildingNumber,
        apartmentNumber: adress.ApartmentNumber,
        postalCode: adress.PostalCode,
      })
    );

    setCurrentAdress(adress);
  };

  const handleSubmit = () => {
    const contactAdress =
      (currentAdressFromState as AdressItemType) || adressList?.find((item) => item.AddressType === 9);

    if (currentAdress.AddressType === 7) {
      dispatch(openApplicationEmtpyAdressError());
    } else {
      if (addressInvalid(currentAdress)) {
        onEditChangeAddress();

        // apartmentNumber ve buildingNumber bilgilerini de ekle
        const matchingAdressForExport = adressList.find(
          (addr) =>
            addr.CityCode === currentAdress?.CityCode &&
            addr.AddressDetail === currentAdress?.AddressDetail &&
            addr.Town === currentAdress?.Town
        );

        fillExportedData({
          cityCode: currentAdress.CityCode,
          town: currentAdress.Town,
          district: currentAdress.District,
          street: currentAdress.Street,
          adressDetail: currentAdress.AddressDetail,
          adressType: currentAdress.AddressType,
          postCode: currentAdress.PostalCode,
          apartmentNumber: matchingAdressForExport?.ApartmentNumber || currentAdress.ApartmentNumber,
          buildingNumber: matchingAdressForExport?.BuildingNumber || currentAdress.BuildingNumber,
        });
        return;
      } else if (contactAdress && !contactAdress?.Street) {
        dispatch(openEmptyStreetError());
        return;
      } else {
        // apartmentNumber ve buildingNumber bilgilerini de ekle
        const matchingAdressForFinalExport = adressList.find(
          (addr) =>
            addr.CityCode === currentAdress?.CityCode &&
            addr.AddressDetail === currentAdress?.AddressDetail &&
            addr.Town === currentAdress?.Town
        );

        fillExportedData({
          cityCode: currentAdress.CityCode,
          town: currentAdress.Town,
          district: currentAdress.District,
          street: currentAdress.Street,
          adressDetail: currentAdress.AddressDetail,
          adressType: currentAdress.AddressType,
          postCode: currentAdress.PostalCode,
          apartmentNumber: matchingAdressForFinalExport?.ApartmentNumber || currentAdress.ApartmentNumber,
          buildingNumber: matchingAdressForFinalExport?.BuildingNumber || currentAdress.BuildingNumber,
        });
        dispatch(
          setActiveUserAdress({
            adressDetail: currentAdress.AddressDetail,
            adressType: currentAdress.AddressType.toString(),
            cityCode: currentAdress.CityCode.toString(),
            town: currentAdress.Town,
            district: currentAdress.District,
            street: currentAdress.Street,
            buildingNumber: currentAdress.BuildingNumber,
            apartmentNumber: currentAdress.ApartmentNumber,
            postalCode: currentAdress.PostalCode,
          })
        );
        dispatch(incStep());
      }
    }
  };

  const handleAddressChange = (event: any) => {
    const selectedAddressIndex = Number(event.target.value);

    // -2 değeri yeni girilen adres için özel değer, bu durumda currentAdress'i koru
    if (selectedAddressIndex === -2) {
      return;
    }

    // -1 ise hiçbir şey seçilmemiş demek
    if (selectedAddressIndex === -1) {
      return;
    }

    const selectedAddress = adressList[selectedAddressIndex];
    if (selectedAddress) {
      setDefaultAdress(selectedAddress);
    }
  };

  return (
    <div id="adressList">
      <FormControl fullWidth className="adressList__dropdown" ref={formControlRef}>
        <Select
          value={selectValue}
          onChange={handleAddressChange}
          
          displayEmpty
          variant="outlined"
          className="adressList__select"
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                width: formControlRef.current?.offsetWidth || 'auto',
              },
            },
          }}
          renderValue={(selected) => {
            if (selected === -1 || selected === undefined) {
              return <em>Adres seçiniz</em>;
            }

            return (
              <Box className="adressList__selected-address">
                <LocationIcon className="locationIcon" />
                <Box className="adressList__adress-detail">
                  <Typography variant="h3">
                    <Box fontWeight={600} fontSize={fontSizes.regular}>
                      {currentAdress?.Town || currentAdress?.District || 'Adres'}
                    </Box>
                  </Typography>
                  <Typography className="adressList__adress-detail__desc" variant="body1">
                    {formatAddressText(currentAdress?.AddressDetail, currentAdress?.BuildingNumber, currentAdress?.ApartmentNumber)}
                  </Typography>
                </Box>
              </Box>
            );
          }}
        >
          {/* Yeni girilen adres için MenuItem (eğer adres listede yoksa) */}
          {currentAdress?.AddressDetail &&
            adressList.findIndex(
              (addr) =>
                addr.CityCode === currentAdress?.CityCode &&
                addr.AddressDetail === currentAdress?.AddressDetail &&
                addr.Town === currentAdress?.Town
            ) === -1 && (
              <MenuItem key="new-address" value={-2}>
                <Box className="adressList__menu-item" width="100%">
                  <Typography variant="h3">
                    <Box fontWeight={600} fontSize={fontSizes.regular} color={colors.secondary}>
                      {currentAdress.Town}
                    </Box>
                  </Typography>
                  <Typography
                    variant="body1"
                    className="adressList__menu-item__desc"
                    style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                  >
                    {formatAddressText(currentAdress.AddressDetail, currentAdress.BuildingNumber, currentAdress.ApartmentNumber)}
                  </Typography>
                </Box>
              </MenuItem>
            )}

          {adressList.map((item, originalIndex) =>
            Number(item.AddressType) !== 7 ? (
              <MenuItem key={`${item.CityCode}-${originalIndex}`} value={originalIndex}>
                <Box className="adressList__menu-item" width="100%">
                  <Typography variant="h3">
                    <Box fontWeight={600} fontSize={fontSizes.regular} color={colors.secondary}>
                      {item.Town}
                    </Box>
                  </Typography>
                  <Typography
                    variant="body1"
                    className="adressList__menu-item__desc"
                    style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                  >
                    {formatAddressText(item.AddressDetail, item.BuildingNumber, item.ApartmentNumber)}
                  </Typography>
                </Box>
              </MenuItem>
            ) : null
          )}
        </Select>
      </FormControl>

      <Box mt={gutters.small}>
        <Button
          fullWidth
          variant="outlined"
          color="secondary"
          onClick={() => setIsAddNewAdress(true)}
          itemID="addNewAdressCardApplicationBtnTest"
        >
          + {web_enter_new_address}
        </Button>
      </Box>

      <Box mt={gutters.small}>
        <Button
          onClick={handleSubmit}
          color="secondary"
          fullWidth
          variant="contained"
          itemID="cardApplicationNextBtnTest"
        >
          Devam et
        </Button>
      </Box>

      <DialogWithActions
        alignTitle="left"
        primaryButton={{
          label: web_btn_okay,
          handleClick: () => dispatch(closeApplicationEmtpyAdressError()),
        }}
        open={applicationEmtpyAdressError}
        hide={() => dispatch(closeApplicationEmtpyAdressError())}
        title={
          currentAdress.AddressType === 7
            ? web_card_incorrect_adkn_address_alert_title
            : web_card_incorrect_address_alert_title
        }
        text={
          currentAdress.AddressType === 7
            ? web_card_incorrect_adkn_address_alert_desc
            : web_card_incorrect_address_alert_desc
        }
      />
    </div>
  );
};
export default AdressList;
